import React from "react";
import ReactGA from "react-ga";
import { connect } from "react-redux";
import {
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from "react-router";
import { Spinner } from "src/components/Spinner";
import { routes } from "src/constants/routes";
import { storage } from "src/constants/storage";
import { ReportBuilderPage } from "src/containers/ReportBuilderPage";
import { ReportManager } from "src/containers/ReportManager";
import { IAppState } from "src/models/state";
import { IUser } from "src/models/user";
import { IAsyncState } from "src/state/action";
import { loadCurrentUser } from "src/state/login/actions";
import "src/style/components/custom-colors.css";
import { GOOGLE_ANALYTICS_KEY } from "../../constants/googleAnalytics";
import { ExamplesBizChartsPage } from "../ExampleBizCharts";
import { ExamplesChartsJSPage } from "../ExampleChartsJS";

// #region -------------- Interfaces -------------------------------------------------------------------

interface IStateProps {
  currentUser: IAsyncState<IUser>;
}

interface IDispatchProps {
  onLoadCurrentUser(): void;
}

interface IOwnProps {}

interface IProps
  extends IStateProps,
    IDispatchProps,
    IOwnProps,
    RouteComponentProps {}

// #endregion

// #region -------------- Component -------------------------------------------------------------------

class App extends React.Component<IProps> {
  public componentDidMount() {
    this.initializeGoogleAnalytics();
    this.reportToGoogleAnalytics();

    const sessionID = localStorage.getItem(storage.sessionIdKey);

    if (sessionID) {
      this.props.onLoadCurrentUser();
    }
  }

  public componentDidUpdate() {
    this.reportToGoogleAnalytics();
  }

  public initializeGoogleAnalytics() {
    ReactGA.initialize(GOOGLE_ANALYTICS_KEY);
  }

  public reportToGoogleAnalytics() {
    ReactGA.pageview(window.location.pathname);
  }

  public render() {
    const { currentUser } = this.props;
    const sessionID = localStorage.getItem(storage.sessionIdKey);

    if (sessionID && (!currentUser || !currentUser.data)) {
      return <Spinner />;
    }

    return (
      <div className="rb-app-body">
        <Switch>
          <Redirect exact path={routes.root} to={routes.manager} />
          <Route exact path={routes.manager} component={ReportManager} />
          <Route exact path={routes.builder} component={ReportBuilderPage} />
          <Route
            exact
            path={`${routes.report}/:id`}
            component={ReportBuilderPage}
          />
          <Route
            exact
            path={[routes.ExampleBizCharts, routes.ExampleBizChartsHTML]}
            component={ExamplesBizChartsPage}
          />
          <Route
            exact
            path={[routes.ExampleChartsJS, routes.ExampleChartsJSHTML]}
            component={ExamplesChartsJSPage}
          />
          <Redirect to={routes.manager} />
        </Switch>
      </div>
    );
  }
}

// #endregion

// #region -------------- Connect -------------------------------------------------------------------

const connected = connect<IStateProps, IDispatchProps, IOwnProps, IAppState>(
  (state) => {
    return {
      currentUser: state.login && state.login.currentUser,
    };
  },
  (dispatch) => {
    return {
      onLoadCurrentUser: () => dispatch(loadCurrentUser()),
    };
  }
)(App);

// #endregion

export default withRouter(connected);
